import { BASE_CRM_URL } from 'shared/constants/defaultENV'

type PropType = { name: string; id?: string; etc?: number }

const CallerAccountName = (props: PropType) => {
  const { id, name, etc } = props
  const href = `${BASE_CRM_URL}?etc=${etc}&pagetype=entityrecord&id=${id}`

  return (
    <a
      href={href}
      className={'focus-visible:outline-0'}
      onClick={(e) => {
        e.preventDefault()
        if (id && etc)
          window.open(
            href,
            'Snopzer',
            'left=20,top=20,width=1360,height=768,toolbar=1,resizable=0'
          )
      }}
    >
      <p className="mr-4 font-medium text-3.25 leading-5.5 mb-6">{`شرکت: ${
        name || ' - '
      }`}</p>
    </a>
  )
}

export default CallerAccountName
